import { AdminUsersResult } from "@futuri/cloudsso-client/src/client/types/admin";
import { AdminModuleState } from ".";

export const SET_ADMIN_USERS_RESULT = async (
  state: AdminModuleState,
  users: AdminUsersResult | undefined
) => {
  state.usersResult = users;
};

export const SET_CURRENT_USER_EMAIL = async (
  state: AdminModuleState,
  id: string
) => {
  state.currentUserEmail = id;
};
